module.exports = __webpack_public_path__ + "img/sleeve_length.b651030f.png";